/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { settingControllerGet } from '../fn/setting/setting-controller-get';
import { SettingControllerGet$Params } from '../fn/setting/setting-controller-get';
import { settingControllerGetAll } from '../fn/setting/setting-controller-get-all';
import { SettingControllerGetAll$Params } from '../fn/setting/setting-controller-get-all';
import { settingControllerGetBusinessInfo } from '../fn/setting/setting-controller-get-business-info';
import { SettingControllerGetBusinessInfo$Params } from '../fn/setting/setting-controller-get-business-info';
import { settingControllerGetSettlementConfig } from '../fn/setting/setting-controller-get-settlement-config';
import { SettingControllerGetSettlementConfig$Params } from '../fn/setting/setting-controller-get-settlement-config';
import { settingControllerSetBusinessInfo } from '../fn/setting/setting-controller-set-business-info';
import { SettingControllerSetBusinessInfo$Params } from '../fn/setting/setting-controller-set-business-info';
import { settingControllerSetSettings } from '../fn/setting/setting-controller-set-settings';
import { SettingControllerSetSettings$Params } from '../fn/setting/setting-controller-set-settings';
import { settingControllerSetSettlementConfig } from '../fn/setting/setting-controller-set-settlement-config';
import { SettingControllerSetSettlementConfig$Params } from '../fn/setting/setting-controller-set-settlement-config';
import { SettingDto } from '../models/setting-dto';

@Injectable({ providedIn: 'root' })
export class SettingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `settingControllerGetAll()` */
  static readonly SettingControllerGetAllPath = '/api/setting';

  /**
   * 모든 설정 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerGetAll$Response(params?: SettingControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SettingDto>>> {
    const obs = settingControllerGetAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 모든 설정 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerGetAll(params?: SettingControllerGetAll$Params, context?: HttpContext): Observable<Array<SettingDto>> {
    const resp = this.settingControllerGetAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SettingDto>>): Array<SettingDto> => r.body)
    );
  }

  /** Path part for operation `settingControllerSetSettings()` */
  static readonly SettingControllerSetSettingsPath = '/api/setting';

  /**
   * 설정 저장 (단일 또는 다중).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingControllerSetSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingControllerSetSettings$Response(params: SettingControllerSetSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = settingControllerSetSettings(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 설정 저장 (단일 또는 다중).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingControllerSetSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingControllerSetSettings(params: SettingControllerSetSettings$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.settingControllerSetSettings$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `settingControllerGetBusinessInfo()` */
  static readonly SettingControllerGetBusinessInfoPath = '/api/setting/business-info';

  /**
   * 사업자 정보 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingControllerGetBusinessInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerGetBusinessInfo$Response(params?: SettingControllerGetBusinessInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
    const obs = settingControllerGetBusinessInfo(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사업자 정보 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingControllerGetBusinessInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerGetBusinessInfo(params?: SettingControllerGetBusinessInfo$Params, context?: HttpContext): Observable<{
}> {
    const resp = this.settingControllerGetBusinessInfo$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `settingControllerSetBusinessInfo()` */
  static readonly SettingControllerSetBusinessInfoPath = '/api/setting/business-info';

  /**
   * 사업자 정보 저장.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingControllerSetBusinessInfo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingControllerSetBusinessInfo$Response(params: SettingControllerSetBusinessInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = settingControllerSetBusinessInfo(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 사업자 정보 저장.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingControllerSetBusinessInfo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingControllerSetBusinessInfo(params: SettingControllerSetBusinessInfo$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.settingControllerSetBusinessInfo$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `settingControllerGetSettlementConfig()` */
  static readonly SettingControllerGetSettlementConfigPath = '/api/setting/settlement-config';

  /**
   * 정산 수수료 설정 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingControllerGetSettlementConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerGetSettlementConfig$Response(params?: SettingControllerGetSettlementConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * 두당 사육관리비 (원)
 */
'farmManagementFeePerPig'?: number;

/**
 * 공모 수수료율 (예: 0.015 = 1.5%)
 */
'offeringFeeRate'?: number;

/**
 * 초과수익 수수료율 (예: 0.38 = 38%)
 */
'excessProfitFeeRate'?: number;

/**
 * 기준 수익률 (예: 0.11 = 11%)
 */
'excessProfitThreshold'?: number;

/**
 * 소득세율 (예: 0.14 = 14%)
 */
'incomeTaxRate'?: number;

/**
 * 지방소득세율 (예: 0.014 = 1.4%)
 */
'localTaxRate'?: number;
}>> {
    const obs = settingControllerGetSettlementConfig(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 정산 수수료 설정 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingControllerGetSettlementConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerGetSettlementConfig(params?: SettingControllerGetSettlementConfig$Params, context?: HttpContext): Observable<{

/**
 * 두당 사육관리비 (원)
 */
'farmManagementFeePerPig'?: number;

/**
 * 공모 수수료율 (예: 0.015 = 1.5%)
 */
'offeringFeeRate'?: number;

/**
 * 초과수익 수수료율 (예: 0.38 = 38%)
 */
'excessProfitFeeRate'?: number;

/**
 * 기준 수익률 (예: 0.11 = 11%)
 */
'excessProfitThreshold'?: number;

/**
 * 소득세율 (예: 0.14 = 14%)
 */
'incomeTaxRate'?: number;

/**
 * 지방소득세율 (예: 0.014 = 1.4%)
 */
'localTaxRate'?: number;
}> {
    const resp = this.settingControllerGetSettlementConfig$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{

/**
 * 두당 사육관리비 (원)
 */
'farmManagementFeePerPig'?: number;

/**
 * 공모 수수료율 (예: 0.015 = 1.5%)
 */
'offeringFeeRate'?: number;

/**
 * 초과수익 수수료율 (예: 0.38 = 38%)
 */
'excessProfitFeeRate'?: number;

/**
 * 기준 수익률 (예: 0.11 = 11%)
 */
'excessProfitThreshold'?: number;

/**
 * 소득세율 (예: 0.14 = 14%)
 */
'incomeTaxRate'?: number;

/**
 * 지방소득세율 (예: 0.014 = 1.4%)
 */
'localTaxRate'?: number;
}>): {

/**
 * 두당 사육관리비 (원)
 */
'farmManagementFeePerPig'?: number;

/**
 * 공모 수수료율 (예: 0.015 = 1.5%)
 */
'offeringFeeRate'?: number;

/**
 * 초과수익 수수료율 (예: 0.38 = 38%)
 */
'excessProfitFeeRate'?: number;

/**
 * 기준 수익률 (예: 0.11 = 11%)
 */
'excessProfitThreshold'?: number;

/**
 * 소득세율 (예: 0.14 = 14%)
 */
'incomeTaxRate'?: number;

/**
 * 지방소득세율 (예: 0.014 = 1.4%)
 */
'localTaxRate'?: number;
} => r.body)
    );
  }

  /** Path part for operation `settingControllerSetSettlementConfig()` */
  static readonly SettingControllerSetSettlementConfigPath = '/api/setting/settlement-config';

  /**
   * 정산 수수료 설정 저장.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingControllerSetSettlementConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingControllerSetSettlementConfig$Response(params: SettingControllerSetSettlementConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = settingControllerSetSettlementConfig(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 정산 수수료 설정 저장.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingControllerSetSettlementConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settingControllerSetSettlementConfig(params: SettingControllerSetSettlementConfig$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.settingControllerSetSettlementConfig$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `settingControllerGet()` */
  static readonly SettingControllerGetPath = '/api/setting/{key}';

  /**
   * 단일 설정 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settingControllerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerGet$Response(params: SettingControllerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingDto>> {
    const obs = settingControllerGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 단일 설정 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settingControllerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settingControllerGet(params: SettingControllerGet$Params, context?: HttpContext): Observable<SettingDto> {
    const resp = this.settingControllerGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SettingDto>): SettingDto => r.body)
    );
  }

}
